import React from "react";
import "../About.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { motion } from "framer-motion";
import aboutBanner from "../../../assets/dashboard-3.jfif";

import {
    FaShieldAlt,
    FaBullseye,
    FaEye,
    FaUsers,
    FaLock,
    FaCloud,
    FaNetworkWired,
    FaCheckCircle
} from "react-icons/fa";



const values = [

    {
        icon: <FaShieldAlt />,
        title: "Security First Approach",
        desc: "We prioritize security at every level by combining advanced technologies, industry best practices, and proactive defense strategies."
    },

    {
        icon: <FaUsers />,
        title: "Expert Security Team",
        desc: "Our cybersecurity professionals bring deep technical expertise to protect organizations against evolving digital threats."
    },


    {
        icon: <FaLock />,
        title: "Trust & Reliability",
        desc: "We build long-term partnerships by delivering transparent, reliable, and effective cybersecurity solutions."
    },


    {
        icon: <FaCloud />,
        title: "Future Ready Solutions",
        desc: "We help businesses stay secure with modern cloud security, infrastructure protection, and emerging technologies."
    }

];



const expertise = [

    "Cyber Threat Monitoring",

    "Network & Infrastructure Security",

    "Cloud Security Protection",

    "Risk Assessment & Compliance",

    "Incident Response Management",

    "Vulnerability Assessment"

];



const About = () => {


    return (

        <>

            <Header />


            <title>
                About BlueLotus Infrasafety Projects Private Limited | Cybersecurity Solutions
            </title>



            <section className="about-hero" style={{
                backgroundImage: `url(${aboutBanner})`
            }}>


                <div className="container">


                    <motion.div

                        className="about-hero-content"

                        initial={{ opacity: 0, y: 50 }}

                        animate={{ opacity: 1, y: 0 }}

                        transition={{ duration: .8 }}

                    >


                        <span className="about-tag">

                            Cybersecurity Experts

                        </span>


                        <h1>

                            Protecting Businesses
                            <span>
                                In The Digital World
                            </span>

                        </h1>


                        <p>

                            BlueLotus Infrasafety Projects Private Limited delivers
                            advanced cybersecurity solutions designed to
                            protect organizations from modern cyber threats,
                            data breaches, and digital risks.

                        </p>


                    </motion.div>


                </div>

            </section>






            {/* ABOUT COMPANY */}


            <section className="about-company">


                <div className="container about-grid">


                    <div className="about-text">


                        <h2>

                            Who We Are

                        </h2>


                        <p>

                            BlueLotus Infrasafety Projects Private Limited is a
                            cybersecurity-focused organization committed
                            to helping businesses build secure, resilient,
                            and trusted digital environments.

                        </p>


                        <p>

                            We combine security expertise, innovative
                            technologies, and proactive monitoring strategies
                            to protect critical business systems, applications,
                            networks, and sensitive information.

                        </p>


                        <p>

                            Our mission is to empower organizations with
                            strong cybersecurity foundations that allow them
                            to confidently operate in an increasingly connected
                            world.

                        </p>


                    </div>




                    <div className="security-box">


                        <div>

                            <FaNetworkWired />

                            <h3>

                                Advanced Protection

                            </h3>

                            <p>

                                Enterprise-grade security solutions for modern
                                digital infrastructure.

                            </p>

                        </div>


                        <div>

                            <FaShieldAlt />

                            <h3>

                                Threat Defense

                            </h3>

                            <p>

                                Continuous monitoring and proactive cyber threat
                                management.

                            </p>

                        </div>


                    </div>


                </div>


            </section>

            {/* OUR STORY */}

            <section className="story-section">

                <div className="container story-grid">


                    <div className="story-image">

                        <div className="story-shield">

                            <FaShieldAlt />

                        </div>

                    </div>



                    <div className="story-content">


                        <span className="about-tag">

                            Our Journey

                        </span>


                        <h2>

                            Building a Safer Digital Future

                        </h2>


                        <p>

                            As cyber threats continue to evolve, organizations need
                            more than traditional security solutions. They need a
                            trusted cybersecurity partner who understands their
                            business challenges and provides proactive protection.

                        </p>


                        <p>

                            BlueLotus Infrasafety Projects Private Limited was established with
                            a vision to help businesses strengthen their digital security
                            posture through innovative technologies, expert knowledge,
                            and strategic security practices.

                        </p>


                        <p>

                            From threat detection and risk management to incident
                            response and compliance support, we help organizations
                            stay prepared against today's complex cyber landscape.

                        </p>


                    </div>


                </div>

            </section>




            {/* MISSION VISION */}


            <section className="mission-section">


                <div className="container mission-grid">


                    <div className="mission-card">


                        <FaBullseye />


                        <h3>

                            Our Mission

                        </h3>


                        <p>

                            To provide reliable cybersecurity solutions that
                            help organizations prevent attacks, reduce risks,
                            and protect their digital assets.

                        </p>


                    </div>



                    <div className="mission-card">


                        <FaEye />


                        <h3>

                            Our Vision

                        </h3>


                        <p>

                            To become a trusted cybersecurity partner by
                            creating safer digital ecosystems for businesses
                            worldwide.

                        </p>


                    </div>


                </div>


            </section>


            <section className="difference-section">

                <div className="container">


                    <div className="section-title">

                        <h2>

                            What Makes BlueLotus Infrasafety Projects Private Limited Different?

                        </h2>

                        <p>

                            A security partner focused on prevention,
                            protection, and continuous improvement.

                        </p>

                    </div>



                    <div className="difference-grid">


                        <div className="difference-card">

                            <h3>

                                Proactive Security

                            </h3>

                            <p>

                                We don't wait for attacks to happen. Our approach
                                focuses on identifying vulnerabilities before they
                                become security incidents.

                            </p>

                        </div>



                        <div className="difference-card">

                            <h3>

                                Advanced Technology

                            </h3>

                            <p>

                                We leverage modern cybersecurity tools,
                                automation, intelligence-driven monitoring,
                                and industry best practices.

                            </p>

                        </div>



                        <div className="difference-card">

                            <h3>

                                Business Focused Protection

                            </h3>

                            <p>

                                Our solutions are designed around your business
                                goals, ensuring security without affecting
                                productivity.

                            </p>

                        </div>


                    </div>


                </div>

            </section>



            {/* VALUES */}


            <section className="values-section">


                <div className="container">


                    <div className="section-title">


                        <h2>

                            Our Core Values

                        </h2>


                        <p>

                            Principles that guide our security solutions and
                            client relationships.

                        </p>


                    </div>



                    <div className="values-grid">


                        {
                            values.map((item, index) => (


                                <motion.div

                                    className="value-card"

                                    key={index}

                                    whileInView={{ opacity: 1, y: 0 }}

                                    initial={{ opacity: 0, y: 40 }}

                                    viewport={{ once: true }}

                                >


                                    <div className="value-icon">

                                        {item.icon}

                                    </div>


                                    <h3>

                                        {item.title}

                                    </h3>


                                    <p>

                                        {item.desc}

                                    </p>


                                </motion.div>


                            ))

                        }


                    </div>


                </div>


            </section>



            <section className="approach-section">


                <div className="container">


                    <div className="section-title">


                        <h2>

                            Our Cybersecurity Approach

                        </h2>


                        <p>

                            A structured approach to protecting your digital ecosystem.

                        </p>


                    </div>



                    <div className="approach-grid">


                        <div className="approach-item">

                            <span>01</span>

                            <h3>

                                Identify

                            </h3>

                            <p>

                                Discover vulnerabilities, risks, and security gaps
                                across your infrastructure.

                            </p>

                        </div>



                        <div className="approach-item">

                            <span>02</span>

                            <h3>

                                Protect

                            </h3>

                            <p>

                                Implement advanced security controls to safeguard
                                systems and sensitive data.

                            </p>

                        </div>



                        <div className="approach-item">

                            <span>03</span>

                            <h3>

                                Monitor

                            </h3>

                            <p>

                                Continuously monitor threats and suspicious
                                activities using modern security solutions.

                            </p>

                        </div>



                        <div className="approach-item">

                            <span>04</span>

                            <h3>

                                Respond

                            </h3>

                            <p>

                                Quickly detect, contain, and recover from cyber
                                incidents.

                            </p>

                        </div>


                    </div>


                </div>


            </section>




            {/* EXPERTISE */}


            <section className="expertise-section">


                <div className="container">


                    <h2>

                        Our Cybersecurity Expertise

                    </h2>


                    <div className="expertise-grid">


                        {

                            expertise.map((item, index) => (

                                <div className="expertise-item" key={index}>

                                    <FaCheckCircle />

                                    {item}

                                </div>

                            ))

                        }


                    </div>


                </div>


            </section>








            {/* CTA */}


            <section className="about-cta">


                <div className="container">


                    <h2>

                        Secure Your Digital Future With BlueLotus Infrasafety Projects Private Limited

                    </h2>


                    <p>

                        Partner with cybersecurity specialists who
                        understand today's evolving threat landscape.

                    </p>


                    <a href="/contact">

                        Contact Security Experts

                    </a>


                </div>


            </section>




            <Footer />

        </>

    )

}


export default About;